import { ErrorBase } from '@/errors/ErrorBase';

export class TooManyRequestsError extends ErrorBase {
    static get defaultMessage(): string {
        return 'ログインできませんでした。時間をおいてから再度お試しください。';
    }

    static get errorName(): string {
        return 'TooManyRequestsError';
    }
}
